import { applyMiddleware, compose, createStore } from "redux";
import { createBrowserHistory } from "history";
import createSagaMiddleware from "redux-saga";
import { createReduxHistoryContext } from "redux-first-history";
import { createLogger } from "redux-logger";
import sagas from "./sagas";
import createRootReducer from "./reducers";

export const history = createBrowserHistory();

const configureStore = (initialState = {}, services = {}) => {
  const sagaMiddleware = createSagaMiddleware();
  const { routerMiddleware } = createReduxHistoryContext({
    history,
  });
  const middlewares = [sagaMiddleware, routerMiddleware];

  if (process.env.NODE_ENV === "development" && !process.env.REACT_APP_DISABLE_REDUX_LOGS) {
    middlewares.push(createLogger());
  }

  const enhancers = [
    applyMiddleware(...middlewares), // empty for now;
  ];

  /* eslint-disable no-underscore-dangle */
  const composeEnhancers =
    process.env.NODE_ENV !== "production" && typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      : compose;
  /* eslint-disable no-underscore-dangle */

  const store = createStore(createRootReducer(history), initialState, composeEnhancers(...enhancers));

  let sagaTask = sagaMiddleware.run(sagas);

  if (module.hot) {
    const reducersComponent = require("./reducers").default;
    module.hot.accept(reducersComponent, () => {
      const nextReducer = require("./reducers").default;
      store.replaceReducer(nextReducer);
    });

    const sagasComponent = require("./sagas").default;
    module.hot.accept(sagasComponent, () => {
      const nextSagas = require("./sagas").default;
      sagaTask.cancel();
      sagaTask.done.then(() => {
        sagaTask = sagaMiddleware.run(nextSagas, services);
      });
    });
  }

  return store;
};

export default configureStore;

// https://s3.eu-central-1.amazonaws.com/brandification-resized/images/large/
// https://s3.eu-central-1.amazonaws.com/brandification-resized/images/medium/
// https://s3.eu-central-1.amazonaws.com/brandification-resized/images/small/
// https://s3.eu-central-1.amazonaws.com/brandification-resized/images/thumbnail/
